import { useState } from 'preact/hooks';
import CountyFilter from './filters/CountyFilter';
import IndustryFilter from './filters/IndustryFilter';
import PastSearches from './filters/PastSearches';
import SpeciesFilter from './filters/SpeciesFilter';
import TypeFilter from './filters/TypeFilter';

export default function FilterPopup({
	filterData,
	title,
	setIsPopupOpen,
	popupView,
	setPopupView,
	filters,
	setFilters
}) {
	switch (popupView) {
		case 'industries':
			title = 'Næring';
			break;
		case 'counties':
			title = 'Fylke';
			break;
		case 'species':
			title = 'Arter';
			break;
		default:
			title = 'Filtre';
	}

	return (
		<div class="fixed lg:hidden inset-0 z-50 bg-dark bg-opacity-50">
			<div class="absolute bottom-0 h-5/6 inset-x-0 bg-white rounded-t-3xl pt-4 p-6 flex flex-col">
				<div class="flex items-center font-display text-sm font-bold mb-7">
					<div class="w-3/12">
						{popupView !== 'main' && (
							<button
								onClick={() => setPopupView('main')}
								class="text-blue font-display text-sm font-bold"
							>
								<i class="far fa-chevron-left mr-2"></i>
								Filtre
							</button>
						)}
					</div>
					<p class="text-center flex-grow">{title}</p>
					<button
						onClick={() => setIsPopupOpen(false)}
						class="w-3/12 text-right text-2xl"
					>
						<i class="fal fa-times"></i>
					</button>
				</div>

				<div class="flex-grow relative">
					{popupView === 'main' ? (
						<MainView
							setPopupView={setPopupView}
							filters={filters}
							setFilters={setFilters}
						/>
					) : (
						<div class="flex flex-col h-full w-full">
							{popupView === 'industries' ? (
								<IndustryFilter
									isInsidePopup={true}
									industries={filterData?.industries?.nodes}
									filters={filters}
									setFilters={setFilters}
								/>
							) : popupView === 'species' ? (
								<SpeciesFilter
									isInsidePopup={true}
									species={filterData?.species?.nodes}
									filters={filters}
									setFilters={setFilters}
								/>
							) : popupView === 'counties' ? (
								<CountyFilter
									isInsidePopup={true}
									counties={filterData?.counties?.nodes}
									filters={filters}
									setFilters={setFilters}
								/>
							) : (
								''
							)}
						</div>
					)}
				</div>

				<div class="relative">
					<div class="absolute bottom-full inset-x-0 w-full h-28 bg-gradient-to-b from-transparent to-white pointer-events-none"></div>
					<button
						onClick={() => setIsPopupOpen(false)}
						class="w-full bg-yellow py-3 font-bold text-base rounded-md"
					>
						Bruk
					</button>
				</div>
			</div>
		</div>
	);
}

function MainView({ setPopupView, filters, setFilters }) {
	return (
		<div class="absolute w-full h-full inset-0 overflow-y-scroll">
			<TypeFilter filters={filters} setFilters={setFilters} />
			<div class="flex flex-col my-6">
				<button
					onClick={() => setPopupView('industries')}
					class="flex items-center justify-between border-t border-b border-gray py-4 font-display font-bold text-sm"
				>
					Næring
					<i class="far fa-chevron-right"></i>
				</button>
				<button
					onClick={() => setPopupView('species')}
					class="flex items-center justify-between border-b border-gray py-4 font-display font-bold text-sm"
				>
					Arter
					<i class="far fa-chevron-right"></i>
				</button>
				<button
					onClick={() => setPopupView('counties')}
					class="flex items-center justify-between border-b border-gray py-4 font-display font-bold text-sm"
				>
					Fylke
					<i class="far fa-chevron-right"></i>
				</button>
			</div>
			<PastSearches filters={filters} setFilters={setFilters} />
		</div>
	);
}
